unit GA.Return.Types;

interface

{$IFDEF PAS2JS}

uses
  JS;
{$ENDIF}

type

  TTenantIdAndName = class
  public
    Id: Integer;
    TenantId: string;
    Name: string;
  end;

  TGiftAigOrgConfig = class
    Id: Integer;
    TenantId: string;
    /// <summary>
    ///   Only used when a Charity client is managed my an Agent
    /// </summary>
    AgentId: Integer;
    OrganisationKind: String;
    Depth: Integer;
    RefId: string;
    Name: string;
    Status: string;
    LicenseType: string;
    LicenseExpires: TDate;
    AuthUserCount: Integer;
  end;

  TGiftAidOrgData = class(TGiftAigOrgConfig)
    LegalName: string;
    Add1: string;
    Add2: string;
    Add3: string;
    Add4: string;
    Add5: string;
    PostCode: string;
    Country: string;
  end;

  TGAUser = class
    InternalId: Integer;
    // Sphinx App Values - read from JWT?
    OrganisationId: Integer;
//    OrganisationName: string;
    TenantId: string;
    JobTitle: string;
    JobPosition: string;
    Title: string;
    GivenName: string;
    LastName: string;
    Email: string;
    EmailConfirmed: Boolean;
    PhoneNumber: string;

    UserStatus: string; // TUserStatus;
    UserScope: string; // TUserScope;

    function Initials: string;
    function IsAdmin: Boolean;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject); virtual;
{$ENDIF}
  end;

  TGiftAidUser = class(TGAUser)
    // Local App Values
    HMRCPhone: string;
    HMRCPostCode: string;
    HMRCRegistered: Boolean;
    CanSubmit: Boolean;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject); override;
{$ENDIF}

  end;

  TUserCounts = class
    Licensed: Integer;
    Active: Integer;
    Inactive: Integer;
    Archived: Integer;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
    function AvailableSeats: Integer;
  end;

  TAgentCharity = class
    OrganisationId: Integer;
    OrganisationName: string;
    TenantId: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TOrganisationConfiguration = class
    ClearDownSubmission: boolean;
    NoMatching: boolean;
    SaveHMRCPassword: boolean;
    CRMLevel: Integer;
    DonorClaimStatusItemIndex: integer;

{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TComboBoxPairs = Class
      Display: string;
      Value: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;


  TSingleDeclarationData = Class
      Display: string;
      Value: string;
      Used: boolean;
      IsRevoked: Boolean;
      DonationId: integer;
      DeclarationId: integer;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

 TDeclarationData = class
   StatusOk: boolean;
   Id: integer;
   Coverage: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TDonationClaimStatusPreviewRequest = class
  private
    FDonorId: Integer;
    FDonationId: Integer;
    FTransactionDate: string;
    FAmount: Double;
    FSponsored: Boolean;
    FNonGiftaidableByCustomerRequest: Boolean;
    FInlineDonor: Boolean;
    FDonationKind: string;
    FCurrentClaimStatus: string;
    FDonorKind: string;
    FDonorClaimStatus: string;
    FTitle: string;
    FFirstName: string;
    FLastName: string;
    FAdd1: string;
    FPostCode: string;
    FCountryCode: string;
    FDateOfDeath: string;
    FDeclarationStatus: string;
    FDeclarationCoverage: string;
    FDeclarationDateSigned: string;
    FDeclarationDateStarted: string;
  public
    property DonorId: Integer read FDonorId write FDonorId;
    property DonationId: Integer read FDonationId write FDonationId;
    property TransactionDate: string read FTransactionDate write FTransactionDate;
    property Amount: Double read FAmount write FAmount;
    property Sponsored: Boolean read FSponsored write FSponsored;
    property NonGiftaidableByCustomerRequest: Boolean read FNonGiftaidableByCustomerRequest
      write FNonGiftaidableByCustomerRequest;
    property InlineDonor: Boolean read FInlineDonor write FInlineDonor;
    property DonationKind: string read FDonationKind write FDonationKind;
    property CurrentClaimStatus: string read FCurrentClaimStatus write FCurrentClaimStatus;
    property DonorKind: string read FDonorKind write FDonorKind;
    property DonorClaimStatus: string read FDonorClaimStatus write FDonorClaimStatus;
    property Title: string read FTitle write FTitle;
    property FirstName: string read FFirstName write FFirstName;
    property LastName: string read FLastName write FLastName;
    property Add1: string read FAdd1 write FAdd1;
    property PostCode: string read FPostCode write FPostCode;
    property CountryCode: string read FCountryCode write FCountryCode;
    property DateOfDeath: string read FDateOfDeath write FDateOfDeath;
    property DeclarationStatus: string read FDeclarationStatus write FDeclarationStatus;
    property DeclarationCoverage: string read FDeclarationCoverage write FDeclarationCoverage;
    property DeclarationDateSigned: string read FDeclarationDateSigned write FDeclarationDateSigned;
    property DeclarationDateStarted: string read FDeclarationDateStarted write FDeclarationDateStarted;
    function BuildFingerprint: string;
{$IFDEF PAS2JS}
    function ToJSONObject: TJSObject;
{$ENDIF}
  end;

  TDonationClaimStatusPreviewResult = class
    ClaimStatus: string;
    ErrorText: string;
  end;

  TDonationClaimStatusInterrogationStep = class
    Title: string;
    Passed: Boolean;
    Detail: string;
  end;

  TDonationClaimStatusInterrogationResult = class
    DonationId: Integer;
    DonationAmountText: string;
    DonationTransactionDateText: string;
    CurrentClaimStatus: string;
    CurrentErrorText: string;
    ComputedClaimStatus: string;
    ComputedErrorText: string;
    IsLocked: Boolean;
    IsLegacyStatus: Boolean;
    LegacyMessage: string;
    CoveringDeclarationId: Integer;
    CoveringDeclarationCoverage: string;
    CoveringDeclarationSummary: string;
    ClaimId: Integer;
    ClaimStatus: string;
    ClaimInfo: string;
    Steps: TArray<TDonationClaimStatusInterrogationStep>;
  end;

  TPrepareClaimData = class
    Complete: boolean;
    ClaimId: integer;
    DonationCount: integer;
    Amount: currency;
    GiftAid: currency;
    GASDS: currency;
    AggregatedDonations: currency;
    OtherIncome: currency;
    GASDSAdjustments: currency;
    Adjustments: currency;
    CommunityBuildings: currency;

{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TClaimParameters = class
    Complete: boolean;
    OldestDate: string;
    NewestDate: string;
    ImportIds: string;
    ImportFiles: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TRetrievePreparedClaim = class
    Exists: boolean;
    PrepareJobId: integer;
    ClaimId: integer;
    OldestDate: string;
    NewestDate: string;
    ImportId: string;
    ClaimRef: string;
    DonationCount: integer;
    Amount: currency;
    GiftAid: currency;
    GASDS: currency;
    AggregatedDonations: currency;
    OtherIncome: currency;
    GASDSAdjustments: currency;
    Adjustments: currency;
    CommunityBuildings: currency;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

{$IFDEF PAS2JS}
function XDataResponseString(const AResponse: JS.TJSObject; const APropertyName: string): string;
{$ENDIF}


implementation

uses
  System.SysUtils,
  SMX.Auth.Shared;

{ TGiftAidUser }

{$IFDEF PAS2JS}

procedure TGAUser.Assign(Source: JS.TJSObject);
begin
  InternalId := Integer(Source.Properties['InternalId']);
  OrganisationId := Integer(Source.Properties['OrganisationId']);
//  OrganisationName := string(Source.Properties['OrganisationName']);
  TenantId := string(Source.Properties['TenantId']);
  JobTitle := string(Source.Properties['JobTitle']);
  JobPosition := string(Source.Properties['JobPosition']);
  Title := string(Source.Properties['Title']);
  GivenName := string(Source.Properties['GivenName']);
  LastName := string(Source.Properties['LastName']);
  Email := string(Source.Properties['Email']);
  EmailConfirmed := Boolean(Source.Properties['EmailConfirmed']);
  UserStatus := string(Source.Properties['UserStatus']);
  UserScope := string(Source.Properties['UserScope']);
  PhoneNumber := string(Source.Properties['PhoneNumber']);
end;
{$ENDIF}

function TGAUser.Initials: string;
begin
  result := '';
  if not GivenName.IsEmpty then
    result := GivenName.Substring(0, 1).ToUpper;
  if not LastName.IsEmpty then
    result := result + LastName.Substring(0, 1).ToUpper;
  result := result.TrimRight;
end;

function TGAUser.IsAdmin: Boolean;
begin
  result := (UserScope = SCOPE_ADMIN) or (UserScope = SCOPE_SUPERUSER);
end;

{$IFDEF PAS2JS}

procedure TGiftAidUser.Assign(Source: JS.TJSObject);
begin
  inherited;
  HMRCPhone := string(Source.Properties['HMRCPhone']);
  HMRCPostCode := string(Source.Properties['HMRCPostCode']);
  HMRCRegistered := Boolean(Source.Properties['HMRCRegistered']);
  CanSubmit := Boolean(Source.Properties['CanSubmit']);
end;
{$ENDIF}


{ TUserCounts }

function TUserCounts.AvailableSeats: Integer;
begin
  result := Licensed - Active;
end;


{$IFDEF PAS2JS}

procedure TUserCounts.Assign(Source: JS.TJSObject);
begin
  Licensed := Integer(Source['Licensed']);
  Active := Integer(Source['Active']);
  Inactive := Integer(Source['Inactive']);
  Archived := Integer(Source['Archived']);
end;

procedure TAgentCharity.Assign(Source: JS.TJSObject);
begin
  OrganisationId := Integer(Source['OrganisationId']);
  OrganisationName := string(Source['OrganisationName']);
  TenantId := string(Source['TenantId']);
end;


procedure TOrganisationConfiguration.Assign(Source: JS.TJSObject);
begin
  ClearDownSubmission := boolean(Source['ClearDownSubmission']);
  NoMatching := boolean(Source['NoMatching']);
  SaveHMRCPassword := boolean(Source['SaveHMRCPassword']);
  CRMLevel := integer(Source['CRMLevel']);
end;

procedure TComboBoxPairs.Assign(Source: JS.TJSObject);
begin
  Display := string(Source['Display']);
  Value := string(Source['Value']);
end;

procedure TSingleDeclarationData.Assign(Source: JS.TJSObject);
begin
  Display := string(Source['Display']);
  Value := string(Source['Value']);
  Used := boolean(Source['Used']);
  IsRevoked := Boolean(Source['IsRevoked']);
  DonationId := integer(Source['DonationId']);
  DeclarationId := integer(Source['DeclarationId']);
end;

procedure TDeclarationData.Assign(Source: JS.TJSObject);
begin
  StatusOk := boolean(Source['StatusOk']);
  Id := integer(Source['Id']);
  Coverage := string(Source['Coverage']);
end;

function XDataResponseObject(const AResponse: JS.TJSObject): JS.TJSObject;
begin
  Result := nil;
  if not Assigned(AResponse) then
    Exit;

  if Assigned(AResponse['value']) then
    Result := JS.TJSObject(AResponse['value'])
  else
    Result := AResponse;
end;

function XDataResponseString(const AResponse: JS.TJSObject; const APropertyName: string): string;
var
  lObj: JS.TJSObject;
begin
  Result := '';
  lObj := XDataResponseObject(AResponse);
  if Assigned(lObj) and lObj.hasOwnProperty(APropertyName) then
    Result := JS.toString(lObj.Properties[APropertyName]);
end;

function TDonationClaimStatusPreviewRequest.ToJSONObject: TJSObject;
begin
  Result := TJSObject.new;
  Result.Properties['DonorId'] := DonorId;
  Result.Properties['DonationId'] := DonationId;
  Result.Properties['TransactionDate'] := TransactionDate;
  Result.Properties['Amount'] := Amount;
  Result.Properties['Sponsored'] := Sponsored;
  Result.Properties['NonGiftaidableByCustomerRequest'] := NonGiftaidableByCustomerRequest;
  Result.Properties['InlineDonor'] := InlineDonor;
  Result.Properties['DonationKind'] := DonationKind;
  Result.Properties['CurrentClaimStatus'] := CurrentClaimStatus;
  Result.Properties['DonorKind'] := DonorKind;
  Result.Properties['DonorClaimStatus'] := DonorClaimStatus;
  Result.Properties['Title'] := Title;
  Result.Properties['FirstName'] := FirstName;
  Result.Properties['LastName'] := LastName;
  Result.Properties['Add1'] := Add1;
  Result.Properties['PostCode'] := PostCode;
  Result.Properties['CountryCode'] := CountryCode;
  Result.Properties['DateOfDeath'] := DateOfDeath;
  Result.Properties['DeclarationStatus'] := DeclarationStatus;
  Result.Properties['DeclarationCoverage'] := DeclarationCoverage;
  Result.Properties['DeclarationDateSigned'] := DeclarationDateSigned;
  Result.Properties['DeclarationDateStarted'] := DeclarationDateStarted;
end;


procedure TPrepareClaimData.Assign(Source: JS.TJSObject);
begin
  Complete := boolean(Source['Complete']);
  ClaimId := integer(Source['ClaimId']);
  DonationCount := integer(Source['DonationCount']);
  Amount := currency(Source['Amount']);
  GiftAid := currency(Source['GiftAid']);
  GASDS := currency(Source['GASDS']);
  AggregatedDonations := currency(Source['AggregatedDonations']);
  OtherIncome := currency(Source['OtherIncome']);
  GASDSAdjustments := currency(Source['GASDSAdjustments']);
  Adjustments := currency(Source['Adjustments']);
  CommunityBuildings := currency(Source['CommunityBuildings']);
end;

procedure TClaimParameters.Assign(Source: JS.TJSObject);
begin
  OldestDate := string(Source['OldestDate']);
  NewestDate := string(Source['NewestDate']);
  ImportIds := string(Source['ImportIds']);
  ImportFiles := string(Source['ImportFiles']);
end;

procedure TRetrievePreparedClaim.Assign(Source: JS.TJSObject);
begin
  Exists := boolean(Source['Exists']);
  PrepareJobId := integer(Source['PrepareJobId']);
  ClaimId := integer(Source['ClaimId']);
  OldestDate := string(Source['OldestDate']);
  NewestDate := string(Source['NewestDate']);
  ImportId := string(Source['ImportId']);
  ClaimRef := string(Source['ClaimRef']);
  DonationCount := integer(Source['DonationCount']);
  Amount := currency(Source['Amount']);
  GiftAid := currency(Source['GiftAid']);
  GASDS := currency(Source['GASDS']);
  AggregatedDonations := currency(Source['AggregatedDonations']);
  OtherIncome := currency(Source['OtherIncome']);
  GASDSAdjustments := currency(Source['GASDSAdjustments']);
  Adjustments := currency(Source['Adjustments']);
  CommunityBuildings := currency(Source['CommunityBuildings']);
end;

{$ENDIF}

function TDonationClaimStatusPreviewRequest.BuildFingerprint: string;
begin
  Result :=
    IntToStr(DonorId) + '|' +
    IntToStr(DonationId) + '|' +
    TransactionDate + '|' +
    CurrToStr(Amount) + '|' +
    BoolToStr(Sponsored, True) + '|' +
    BoolToStr(NonGiftaidableByCustomerRequest, True) + '|' +
    BoolToStr(InlineDonor, True) + '|' +
    DonationKind + '|' +
    CurrentClaimStatus + '|' +
    DonorKind + '|' +
    DonorClaimStatus + '|' +
    Title + '|' +
    FirstName + '|' +
    LastName + '|' +
    Add1 + '|' +
    PostCode + '|' +
    CountryCode + '|' +
    DateOfDeath + '|' +
    DeclarationStatus + '|' +
    DeclarationCoverage + '|' +
    DeclarationDateSigned + '|' +
    DeclarationDateStarted;
end;

end.
